export default __webpack_public_path__ + "static/media/sh-hl.150f1e0c.svg";